import { useField, useForm, notEmpty } from '@shopify/react-form';
import gettext from '@sdk/lang/gettext';

import { FormSubmitStatuses } from '@web/forms/types';
import { PointOfSale } from '@web/onboarding/types';

type Props = {
  selected: PointOfSale;
  onSubmit: (pos: PointOfSale | null, posOther: string | null) => void;
};

export const usePointOfSale = ({ selected, onSubmit }: Props) => {
  const form = useForm({
    fields: {
      pos: useField<PointOfSale>(
        {
          value: selected,
          validates: [notEmpty(gettext('Please specify your POS'))],
        },
        [selected]
      ),
      posName: useField<string>(
        {
          value: '',
          validates: [
            (val) => {
              if (val.length > 50) {
                return gettext('Must be less than 50 characters long');
              }

              if (selected === PointOfSale.other && !val) {
                return gettext('Please specify your POS');
              }
            },
          ],
        },
        [selected]
      ),
    },
    onSubmit: async (values) => {
      try {
        await onSubmit(values.pos, values.posName || '');
        return { status: FormSubmitStatuses.success };
      } catch (e) {
        return { status: FormSubmitStatuses.fail, errors: [] };
      }
    },
  });

  return { form };
};
